import React from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles, Theme, UIBox } from "./index";
import UIButton from "./ui/UIButton";
import UITypography from "./ui/UITypography";
import Main from "./layout/Main";
import { ArrowBack as ArrowBackIcon, Lock as LockIcon } from "../../_core/components/icons";


const NotAuthorized = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Main title="Access Denied" data-testid="not-authorized-container">
      <UIBox className={classes.container}>
        <UIBox className={classes.content}>
          <LockIcon className={classes.icon} />
          <UITypography variant="h4" className={classes.title}>
            Not Authorized
          </UITypography>
          <UITypography variant="body1" className={classes.message}>
            You do not have permission to access this page. Contact your administrator if you believe this is an error.
          </UITypography>
          <UIButton
            variant="contained"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate("/")}
            className={classes.backButton}
          >
            Back to Home
          </UIButton>
        </UIBox>
      </UIBox>
    </Main>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
  },
  content: {
    textAlign: "center",
    maxWidth: 400,
    padding: 24,
  },
  icon: {
    fontSize: 64,
    color: theme.palette.warning.main,
    marginBottom: 16,
  },
  title: {
    marginBottom: 16,
    fontWeight: 600,
  },
  message: {
    marginBottom: 32,
    color: theme.palette.text.secondary,
  },
  backButton: {
    minWidth: 160,
  },
}));

export default NotAuthorized;